module.exports = __webpack_public_path__ + "img/tmenu5.da4fc88d.png";